// Copyright (c) 2020-2024 Uber Technologies Inc.
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import getEventConnections from './get-event-connections';

const setDirectAndInferredChildren = ({
  edges,
  eventIds,
  events,
  node,
  parentArray,
}) => {
  const { eventId } = node;
  const { parent, inferredChild } = getEventConnections(node, events);

  if (parent && eventIds[parent] && eventIds[eventId]) {
    parentArray.push(parent);
    edges.push({
      group: 'edges',
      data: { source: parent, target: eventId, type: 'direct' },
    });
  }

  if (inferredChild && eventIds[inferredChild]) {
    parentArray.push(eventId);
    edges.push({
      group: 'edges',
      data: { source: eventId, target: inferredChild, type: 'inferred' },
    });
  }
};

export default setDirectAndInferredChildren;



// WEBPACK FOOTER //
// ./client/containers/workflow-history/components/workflow-graph/helpers/set-direct-and-inferred-children.js